import { CrossMarkSVG } from '@media/svgs/CrossMarkSVG'
import { RightArrowSVG } from '@media/svgs/RightArrowSVG'
import { BUY_BONUS_TEXTS } from '@constants/buyBonusConstants'

// Pure render — selected package summary + Proceed. All state lives in
// useBuyBonusFlow; this component only receives and displays it.
const BuyBonusPackageCheckout = ({
  selectedPackage,
  currencyCode,
  isPurchasing,
  onBack,
  onClose,
  onPurchase,
}) => {
  const TEXTS = BUY_BONUS_TEXTS.PACKAGE_CHECKOUT

  return (
    <div className="standard-normal-buy-bonus-checkout-outer-container">
      <div className="standard-normal-buy-bonus-checkout-inner-container">
        <div className="standard-normal-buy-bonus-checkout-header-container">
          <div className="standard-normal-buy-bonus-checkout-header-left-container">
            <div className="standard-normal-buy-bonus-checkout-back-icon" onClick={onBack}>
              <RightArrowSVG width="24px" height="24px" />
            </div>
          </div>
          <div className="standard-normal-buy-bonus-checkout-header-center-container">
            <div className="standard-normal-buy-bonus-checkout-header-title">
              {TEXTS.PAGE_TITLE_LABEL}
            </div>
            <div className="standard-normal-buy-bonus-checkout-header-package-value">
              {currencyCode} {selectedPackage?.packageValue}
            </div>
          </div>
          <div className="standard-normal-buy-bonus-checkout-header-right-container">
            <div className="standard-normal-buy-bonus-checkout-close-icon" onClick={onClose}>
              <CrossMarkSVG width="20px" height="20px" />
            </div>
          </div>
        </div>

        <div className="standard-normal-buy-bonus-checkout-divider" />

        <div className="standard-normal-buy-bonus-checkout-body-container">
          <div className="standard-normal-buy-bonus-checkout-details-container">
            <div className="standard-normal-buy-bonus-checkout-detail-row">
              <span className="standard-normal-buy-bonus-checkout-detail-label">
                {TEXTS.PACKAGE_NAME_LABEL}
              </span>
              <span className="standard-normal-buy-bonus-checkout-detail-value">
                {selectedPackage?.name}
              </span>
            </div>
            <div className="standard-normal-buy-bonus-checkout-detail-row">
              <span className="standard-normal-buy-bonus-checkout-detail-label">
                {TEXTS.NUMBER_OF_FREEBETS_LABEL}
              </span>
              <span className="standard-normal-buy-bonus-checkout-detail-value">
                {selectedPackage?.freebets}
              </span>
            </div>
            <div className="standard-normal-buy-bonus-checkout-detail-row">
              <span className="standard-normal-buy-bonus-checkout-detail-label">
                {TEXTS.STAKE_AMOUNT_PER_FREEBET_LABEL}
              </span>
              <span className="standard-normal-buy-bonus-checkout-detail-value">
                {currencyCode} {selectedPackage?.stakePerFreebet}
              </span>
            </div>
            <div className="standard-normal-buy-bonus-checkout-detail-row">
              <span className="standard-normal-buy-bonus-checkout-detail-label">
                {TEXTS.TOTAL_AMOUNT_LABEL}
              </span>
              <span className="standard-normal-buy-bonus-checkout-detail-value">
                {currencyCode} {selectedPackage?.packageValue}
              </span>
            </div>

            {Boolean(selectedPackage?.jackpotRatio) && (
              <>
                <div className="standard-normal-buy-bonus-checkout-detail-divider" />
                <div className="standard-normal-buy-bonus-checkout-detail-row">
                  <span className="standard-normal-buy-bonus-checkout-detail-label">
                    {TEXTS.JACKPOT_RATIO_LABEL}
                  </span>
                  <span className="standard-normal-buy-bonus-checkout-detail-value">
                    {selectedPackage.jackpotRatio}x
                  </span>
                </div>
              </>
            )}
          </div>

          <div className="standard-normal-buy-bonus-checkout-proceed-container">
            <button
              className={`standard-normal-buy-bonus-checkout-proceed-button ${isPurchasing ? 'disable-actions' : ''}`}
              onClick={onPurchase}
              disabled={isPurchasing}
            >
              {isPurchasing ? TEXTS.PROCESSING_BUTTON_TEXT : TEXTS.PROCEED_BUTTON_TEXT}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BuyBonusPackageCheckout
